// extracted by mini-css-extract-plugin
export default {"pageRoot":"CustomLandingPage_pageRoot__AlPwF","buttonsWrapper":"CustomLandingPage_buttonsWrapper__8nPgr","close":"CustomLandingPage_close__81VNO"};